import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { isEqual } from 'lodash'

import { PCTSchema } from './PCTSchema'
import { getParsedTransactions } from './service/getParsedTransactions'

export const PCTRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: `pct-list`,
    component: lazyRouteComponent(() => import('./List/PCT')),
    validateSearch: (search) => PCTSchema.parse(search),
    loaderDeps: (all) => ({
      search: all.search,
      isChanged: !isEqual(PCTSchema.parse({}), all.search)
    }),
    loader: ({ deps }) => getParsedTransactions(deps.search)
  })
